import ActiveFieldIndicator from './util/ActiveFieldIndicator';

function init() {
  initInlineLabels();
}

function initInlineLabels() {
  ActiveFieldIndicator.init({ 
    inputSelector: '.inlineLabelField input, .inlineLabelField textarea, .inlineLabelField select',
    parentSelector: '.inlineLabelField',
    activeClass: 'inlineLabelField--active'
  });
}


export default { init };